import {ApiClientInterface} from "./clients";
import {
  BorrowerOnboarding,
  PrescoreRequest,
  PrescoreValidationResult, ScoreRequest, ScoresCount,
} from "./models";

export class BorrowingOnboardingManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async get(): Promise<BorrowerOnboarding> {
    return this.apiClient.get("");
  }

  public async create(): Promise<BorrowerOnboarding> {
    return this.apiClient.post("");
  }

  public async prescore(prescoreRequest: PrescoreRequest): Promise<PrescoreValidationResult> {
    return this.apiClient.post("/prescore", {prescoreRequest});
  }

  public async scoreCounterparty(innOrOgrn: string): Promise<ScoreRequest> {
    return this.apiClient.post("/score-counterparty", {innOrOgrn});
  }

  public async getScoresCount(): Promise<ScoresCount> {
    return this.apiClient.get("/scores-count");
  }

  public async requestApproval(): Promise<void> {
    return this.apiClient.put("/request-approval");
  }
}